export const MIN_SKELETON_DURATION_MS = 600;

export async function ensureMinimumSkeletonDuration(startedAtMs, minimumMs = MIN_SKELETON_DURATION_MS) {
  const elapsedMs = Date.now() - startedAtMs;
  const remainingMs = Math.max(0, minimumMs - elapsedMs);

  if (remainingMs === 0) {
    return;
  }

  await new Promise((resolve) => {
    setTimeout(resolve, remainingMs);
  });
}
